import { render, staticRenderFns } from "./remoteAirBookingBasic.vue?vue&type=template&id=31b66778&scoped=true&"
import script from "./remoteAirBookingBasic.vue?vue&type=script&lang=js&"
export * from "./remoteAirBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./remoteAirBookingBasic.vue?vue&type=style&index=0&id=31b66778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b66778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b66778')) {
      api.createRecord('31b66778', component.options)
    } else {
      api.reload('31b66778', component.options)
    }
    module.hot.accept("./remoteAirBookingBasic.vue?vue&type=template&id=31b66778&scoped=true&", function () {
      api.rerender('31b66778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/remoteAirBookingBasic.vue"
export default component.exports